const chart = {
  primary: {
    color: 'indigo.60',
    '&:active, &:focus': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'orange.45',
    '&:active, &:focus': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60'
    },
    '&:hover': {
      color: 'indigo.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'orange.60'
    },
    '&:hover': {
      color: 'orange.45'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    margin: 0,
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-26px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'orange.60',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const co = {
  primary: {
    color: 'blue.60',
    '&:active, &:focus': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90'
    },
    '&:hover': {
      color: 'blue.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'blue.60',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-26px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'blue.90',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const edu = {
  primary: {
    color: 'indigo.70',
    '&:active, &:focus': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80'
    },
    '&:hover': {
      color: 'indigo.70'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'coolGrey.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'indigo.70',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-23px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus, &:hover': {
      color: 'indigo.60',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'indigo.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const press = {
  primary: {
    color: 'teal.30',
    '&:active, &:focus': {
      color: 'teal.50'
    },
    '&:hover': {
      color: 'teal.30'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'indigo.60',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'indigo.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'teal.50'
    },
    '&:hover': {
      color: 'teal.30'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'coolGrey.100'
    },
    '&:hover': {
      color: 'indigo.60'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'black',
    fontWeight: 'regular',
    display: 'flex',
    position: 'relative',
    minHeight: '64px',
    alignItems: 'center',
    '&:active, &:focus, &:hover': {
      color: 'teal.30',
      textDecoration: 'none'
    },
    ['@media (min-width: 1023px)']: {
      '&:hover': {
        '&::before': {
          content: '""',
          cursor: 'default',
          position: 'absolute',
          bottom: '0',
          width: '100%',
          backgroundColor: 'teal.30',
          height: '6px'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    textTransform: 'capitalize',
    whiteSpace: 'break-spaces',
    fontWeight: 'regular',
    overflow: 'hidden',
    color: 'coolGrey.100',
    '&:active, &:focus': {
      color: 'teal.30',
      textDecoration: 'underline'
    },
    '&:active, &:focus, &:hover': {
      color: 'teal.30',
      textDecoration: 'none'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'teal.50',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'teal.50',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const spark = {
  primary: {
    color: 'red.50',
    '&:active, &:focus': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.80'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondary: {
    color: 'indigo.90',
    '&:active, &:focus': {
      color: 'indigo.100'
    },
    '&:hover': {
      color: 'indigo.100'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  primaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80'
    },
    '&:hover': {
      color: 'red.50'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  secondaryAlternate: {
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'indigo.90'
    },
    '&:hover': {
      color: 'indigo.90'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  navLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
      textDecoration: 'none'
    },
    '&:hover': {
      color: 'red.50',
      textDecoration: 'none'
    },
    ['@media (min-width: 1000px)']: {
      '&::before': {
        cursor: 'default',
        position: 'absolute',
        bottom: '-23px',
        left: '0',
        width: '100%',
        backgroundColor: 'coolGrey.100',
        height: '4px'
      },
      '&.dropdownBorder': {
        '&::before': {
          content: '""'
        }
      }
    }
  },
  subNavLink: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.50',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  },
  i18nSwitcher: {
    textDecoration: 'none',
    color: 'coolGrey.90',
    '&:active, &:focus': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&:hover': {
      color: 'red.80',
      textDecoration: 'underline'
    },
    '&[aria-disabled="true"]': {
      color: 'coolGrey.30',
      pointerEvents: 'none',
      cursor: 'default'
    }
  }
};

const links = {
  products: {
    chart,
    co,
    edu,
    press,
    spark
  }
};

export default links;
